// Major cities for the birth-place picker (searchable; '其他' allows custom entry).
// Order: 港澳 → 中國 → 台灣 → 其他（海外）.
export const MAJOR_CITIES = [
  // 港澳
  '香港', '澳門',
  // 中國大陸
  '北京', '上海', '廣州', '深圳', '成都', '重慶', '杭州', '南京',
  '武漢', '西安', '天津', '蘇州', '廈門', '福州', '東莞', '佛山',
  '長沙', '鄭州', '青島', '大連', '瀋陽', '哈爾濱', '昆明', '南寧', '海口',
  // 台灣
  '台北市', '新北市', '桃園市', '台中市', '台南市', '高雄市',
  '基隆市', '新竹市', '新竹縣', '嘉義市', '嘉義縣', '苗栗縣',
  '彰化縣', '南投縣', '雲林縣', '屏東縣', '宜蘭縣', '花蓮縣',
  '台東縣', '澎湖縣', '金門縣', '連江縣',
  // 其他（海外）
  '新加坡', '吉隆坡', '曼谷', '馬尼拉', '東京', '大阪', '首爾',
  '多倫多', '溫哥華', '三藩市', '洛杉磯', '紐約', '倫敦', '雪梨', '墨爾本',
];
